import React, { Component } from 'react';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

const PAYMENT_FOR_SCORE = 5;

export default class Statistics extends Component{

  constructor(props) {
    super(props);
  }

  render() {

    const {statistics, app_data} = this.props;

    const operators = app_data.operators;
    console.log(statistics);
    const role = app_data.roles[app_data.user.role_id];
    const showFIlter = role.access.leads.remove

    return (
      <div className={`container`}>

        <p>Расчет ведется по закрытым за данный период заказам</p>

        <table className="table fixed full_width statistics_table">

          <thead>
            <tr>
              <th>Оператор</th>
              <th>Создано доставок оплаченных (1 балл за одну)</th>
              <th>Принято оператором в приемке(оплаченных) (1 балл за один)</th>
              <th>Согласовано оплаченных(1 балл за один)</th>
              <th>Всего баллов</th>
              <th>ЗП(1 балл = 5 руб.)</th>
            </tr>
          </thead>

          <tbody>

          {statistics.operators.operators_by_close.map((operator) => {

            const score = operator.payed_confirmed_count
              + operator.payed_deliveries_created_count
              + operator.payed_created_in_place_count;

            if(!score) {
              return null
            }

            return (
              <tr key={operator.id}>
                <td>{operators[operator.id].title}</td>
                <td>{operator.payed_deliveries_created_count}</td>
                <td>{operator.payed_created_in_place_count}</td>
                <td>{operator.payed_confirmed_count}</td>
                <td>{score}</td>
                <td>{score*PAYMENT_FOR_SCORE}</td>
              </tr>
            )

          })}

          </tbody>
        </table>
        
        <p>Расчет ведется по принятым за данный период заказам</p>

        <table className="table fixed full_width statistics_table">

          <thead>
          <tr>
            <th>Оператор</th>
            <th>Создано обращений</th>
            <th>Создано доставок</th>
            <th>Конверсия в доставку</th>
            <th>Принято оператором в приемке</th>
          </tr>
          </thead>

          <tbody>

          {statistics.operators.operators_by_creation.map((operator) => {

            return (
              <tr key={operator.id}>
                <td>{operators[operator.id].title}</td>
                <td>{operator.leads_created}</td>
                <td>{operator.deliveries_created}</td>
                <td>{operator.leads_created ? Math.round(operator.deliveries_created/operator.leads_created*100) : 0}%</td>
                <td>{operator.created_in_place_count}</td>
              </tr>
            )

          })}

          </tbody>
        </table>  

        {showFIlter && (
          <>
            <p>Расчет ведется по закрытым за данный период заказам</p>

            <table className="table fixed full_width statistics_table">

              <thead>
                <tr>
                  <th>Оператор</th>
                  <th>Создано доставок оплаченных</th>
                  <th>Создано доставок на сумму</th>
                  <th>Принято оператором в приемке</th>
                  <th>Принято оператором в приемке(оплаченных)</th>
                  <th>Принято оператором в приемке на сумму(оплаченных)</th>
                  <th>Согласовано</th>
                  <th>Согласовано оплаченных</th>
                </tr>
              </thead>

              <tbody>

              {statistics.operators.operators_by_close.map((operator) => {

                return (
                  <tr key={operator.id}>
                      <td>{operators[operator.id].title}</td>
                      <td>{operator.payed_deliveries_created_count}</td>
                      <td>{operator.payed_deliveries_money_sum}</td>
                      <td>{operator.created_in_place_count}</td>
                      <td>{operator.payed_created_in_place_count}</td>
                      <td>{operator.payed_created_in_place_money_sum}</td>
                      <td>{operator.confirmed_count}</td>
                      <td>{operator.payed_confirmed_count}</td>
                  </tr>
                )

              })}

              </tbody>
            </table>
          </>
        )}
      </div>
    );

    return (
      <div className={`container`}>

        

        

      </div>
    );
  }
}

